import React, { FC } from 'react'

import { Box, Typography } from '@mui/material'

interface IProps {
  nameOfFile: string
}

const TitleBlock: FC<IProps> = ({ nameOfFile }) => {
  return (
    <Box
      sx={{
        borderRadius: '14px',
        backgroundColor: '#ffffff',
        p: '14px',
        m: 0,
        alignItems: 'center',
      }}
    >
      <Typography sx={{ m: 0 }} variant="h6" gutterBottom>
        Browser Tracing Viewer
        {nameOfFile && (
          <>
            : {'{'} {nameOfFile} {'}'}
          </>
        )}
      </Typography>
    </Box>
  )
}

export default TitleBlock
